import { DEFAULT_LOCALE } from '@mentimeter/i18n-common/constants';
import type { IntlMessagesJson, Locale } from '@mentimeter/i18n-common/types';
import deepmerge from 'deepmerge';

export function resolveTranslations<T = Locale>(
  locale?: T,
  ...translationSources: Partial<Record<string, IntlMessagesJson>>[]
): IntlMessagesJson {
  const l = locale || DEFAULT_LOCALE;
  const resolvedTranslations = translationSources.map((source) => {
    const defaultLocale = source[DEFAULT_LOCALE] || {};
    const userLocale = source[l as keyof typeof source] || {};

    return deepmerge(defaultLocale, userLocale);
  });

  return Object.assign({}, ...resolvedTranslations);
}
